import { render, staticRenderFns } from "./Fuerza.vue?vue&type=template&id=07fa7b6e&scoped=true&"
import script from "./Fuerza.vue?vue&type=script&lang=js&"
export * from "./Fuerza.vue?vue&type=script&lang=js&"
import style0 from "./Fuerza.vue?vue&type=style&index=0&id=07fa7b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa7b6e",
  null
  
)

export default component.exports